// Structure to work:

// <div class="tab-main-parent__js">
//     <div>
//         <div class="tab-heading__js" data-name="1"></div>
//         <div class="tab-heading__js" data-name="2"></div>
//     </div>
//     <div class="tab-containers__js">
//         <div class="tab-container__js" data-name="1"></div>
//         <div class="tab-container__js" data-name="2"></div>
//     </div>
// </div>

document.addEventListener('click', (e) => {
  const selectedTab = e.target.closest('.tab-heading__js')
  const tabContainers = e.target.closest('.tab-main-parent__js')?.querySelector('.tab-containers__js')

  if (selectedTab && !selectedTab.classList.contains('tab-heading__js--active')) {

   if (!tabContainers) return;

      let selectedContainer = tabContainers.querySelector(`.tab-container__js[data-name="${selectedTab.dataset.name}"]`)
      let currentTab = selectedTab.parentElement.querySelector('.tab-heading__js--active')
      let currentContainer = tabContainers.querySelector('.tab-container__js--active')

      changeTab(currentTab, selectedTab)
      changeContainer(currentContainer, selectedContainer)
  }
})

function changeTab(currentTab, selectedTab) {
  currentTab?.classList.remove('tab-heading__js--active')
  selectedTab?.classList.add('tab-heading__js--active')
}

function changeContainer(currentContainer, selectedContainer) {
   currentContainer?.classList.remove('tab-container__js--active')
   selectedContainer?.classList.add('tab-container__js--active')
}